/* istanbul ignore file */
import { SvgIcon, SvgIconProps } from '@mui/material';

export function FigmaVinLocationsIcon(props: any) {
  const image = props.theme.custom.icons.iconVinLocations;
  return (
    <div>
      <img
        src={`data:image/svg+xml;utf8,${encodeURIComponent(image)}`}
        alt="vin locations icon"
        style={{ maxWidth: '100%' }}
      />
    </div>
  );
}

export function FigmaCarIcon(props: any) {
  const image = props.theme.custom.icons.iconAuto;
  return (
    <div>
      <img
        src={`data:image/svg+xml;utf8,${encodeURIComponent(image)}`}
        alt="car icon"
        style={{ width: '39px', height: '33px' }}
      />
    </div>
  );
}

export function FigmaPropertyIcon(props: any) {
  const image = props.theme.custom.icons.iconProperty;
  return (
    <div>
      <img
        src={`data:image/svg+xml;utf8,${encodeURIComponent(image)}`}
        alt="Propoerty icon"
        style={{ width: '36px', height: '36px' }}
      />
    </div>
  );
}

export function WebRedirectIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 40 40">
      <title>Webpage Redirect Icon</title>
      <path d="M21.656 17.2v10.25h-17.075v-17.075h10.119l3.65-3.65h-17.419v24.381h24.375v-17.563zM17.706 0.894v3.481h7.425l-7.55 7.544 2.462 2.463 7.55-7.55v7.431h3.475v-13.369z"></path>
    </SvgIcon>
  );
}

export function ChevronLeftIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <title>Back Button</title>
      <path d="M22.1 0.5l3.3 3.3-12.2 12.2 12.1 12.1-3.3 3.4-15.4-15.5 15.5-15.5z"></path>
    </SvgIcon>
  );
}

export function ChevronRightIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 40 40">
      <title>Left Chevron Button</title>
      <path d="M9.9 31.5l-3.3-3.3 12.2-12.2-12.2-12.1 3.3-3.4 15.5 15.5-15.5 15.5z"></path>
    </SvgIcon>
  );
}

export function AlertIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <title>Alert Icon</title>
      <path d="M16 0.5c-8.563 0-15.5 6.938-15.5 15.5s6.938 15.5 15.5 15.5 15.5-6.938 15.5-15.5-6.938-15.5-15.5-15.5zM17.538 26.2h-3.35v-3.813h3.35v3.813zM17.813 12.744l-1.331 5.638h-1.206l-1.338-5.644v-7.188h3.875v7.194z"></path>
    </SvgIcon>
  );
}

export function SearchIcon() {
  return (
    <SvgIcon width="32" height="32" viewBox="0 0 32 32">
      <title>Search Button</title>
      <path d="M13.714 4.983c4.427 0.058 7.994 3.657 8 8.091v1.349c0 0.745-0.604 1.349-1.349 1.349s-1.349-0.604-1.349-1.349v0-1.349c-0.006-2.945-2.366-5.337-5.297-5.394h-0.005c-0.745 0-1.349-0.604-1.349-1.349s0.604-1.349 1.349-1.349v0zM13.714 0c0.001 0 0.001 0 0.002 0 7.574 0 13.714 6.14 13.714 13.714 0 3.312-1.174 6.35-3.129 8.721l0.019-0.023 7.28 7.303c0.25 0.24 0.405 0.576 0.405 0.949s-0.155 0.709-0.404 0.948v0c-0.242 0.245-0.577 0.397-0.948 0.4h-0.001c-0.369-0.009-0.699-0.165-0.937-0.411v0l-7.291-7.28c-2.346 1.935-5.384 3.109-8.695 3.109-7.574 0-13.714-6.14-13.714-13.714 0-7.569 6.132-13.706 13.7-13.714h0.001zM13.714 24c5.681 0 10.286-4.605 10.286-10.286s-4.605-10.286-10.286-10.286c-5.681 0-10.286 4.605-10.286 10.286v0c0 5.681 4.605 10.286 10.286 10.286v0z"></path>
    </SvgIcon>
  );
}

export function LocationIcon() {
  return (
    <SvgIcon width="26" height="20" viewBox="0 0 26 20">
      <title>Location Icon</title>
      <path d="M17.081 0.231c-0.356-0.038-0.719-0.056-1.081-0.056s-0.725 0.019-1.081 0.056c-6.819 0.694-10.569 8.375-7.494 14.5l8.575 17.094 8.575-17.094c3.075-6.125-0.675-13.806-7.494-14.5zM16 13.6c-1.575 0-2.85-1.275-2.85-2.85s1.275-2.85 2.85-2.85 2.85 1.275 2.85 2.85-1.275 2.85-2.85 2.85z"></path>
    </SvgIcon>
  );
}

export function PreferredShopIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 40 40">
      <title>Preferred Shop Icon</title>
      <path d="M15.969 0.919l3.756 11.275 11.887 0.094-9.563 7.056 3.587 11.337-9.669-6.913-9.669 6.913 3.581-11.337-9.563-7.056 11.887-0.094z"></path>
    </SvgIcon>
  );
}

export function CarDriverFrontIcon() {
  return (
    <SvgIcon viewBox="0 0 40 27">
      <title>Car Driver Front Icon</title>
      <path
        d="M28.8,13.5l0.5-0.1c0,0,0,0,0,0c0.1,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0.1,0,0.1-0.1,0.1h0
	l-0.5,0.1c0,0,0,0,0,0c-0.1,0-0.1-0.1-0.1-0.1v0c0,0,0,0,0,0C28.7,13.6,28.7,13.5,28.8,13.5L28.8,13.5L28.8,13.5z M25.6,14l0.5-0.1
	c0,0,0,0,0,0c0.1,0,0.1,0.1,0.1,0.1c0,0.1,0,0.1-0.1,0.1h0l-0.5,0.1c0,0,0,0,0,0c-0.1,0-0.1-0.1-0.1-0.1l0,0c0,0,0,0,0,0
	C25.5,14.1,25.5,14,25.6,14C25.6,14,25.6,14,25.6,14z M13.5,15.7c0.4-0.2,0.9-0.3,1.5-0.4l0,0c0,0,0,0,0.1,0c0.1,0,0.3,0,0.3,0.1
	l0,0c0.1,0.2,0.2,0.5,0.2,0.8c0,0.5-0.2,1-0.5,1.3l0,0c-0.6,0.2-1.4,0.4-2.1,0.4c-0.1,0-0.2,0-0.3,0l0,0c-0.1,0-0.2,0-0.3,0
	c-0.3,0-0.6,0-0.9-0.1l0,0C11.3,17.6,11.9,16.4,13.5,15.7L13.5,15.7z"
      />
      <path
        d="M21.6,19c0,0.1,0,0.3,0,0.5c0,0.5,0,0.9-0.1,1.4l0-0.1c0-0.3,0.1-0.6,0.1-0.9v0c0-0.1,0-0.1,0-0.2
	C21.7,19.4,21.7,19.2,21.6,19L21.6,19L21.6,19z"
      />
      <path
        d="M32,16.3v-0.1c-0.1-0.7-0.2-1.3-0.3-1.8l0,0.1c-0.1-0.3-0.2-0.6-0.3-0.9l0,0l-0.1-0.3c-0.1-0.1-0.1-0.3-0.2-0.5
	l0,0v-0.1c0-0.2-0.1-0.4-0.3-0.6l0,0c-0.2-0.1-0.4-0.2-0.5-0.3l0,0l-0.4-0.2c-0.2-0.1-0.3-0.2-0.4-0.4l0,0l-0.2-0.2
	c-0.8-1-1.9-1.8-3.1-2.3l0,0c-0.6-0.2-1.4-0.3-2.2-0.4l0,0C22.8,8.1,21.5,8,20.2,8c-2.3,0-4.6,0.2-6.7,0.7l0.2,0L13,8.8
	c-0.1,0-0.2,0.1-0.2,0.1l0,0L12.5,9c-1.7,0.9-3.1,1.8-4.4,2.9l0,0c-0.1,0-0.1,0.1-0.2,0.1h0c-2.5,0.4-4.8,1.3-6.7,2.6l0,0
	c-0.1,0-0.1,0.1-0.2,0.2l0,0c0,0-0.1,0.1-0.1,0.1l0,0l-0.2,0.2H1c-0.2,0.4-0.4,0.8-0.5,1.2l0,0H0.3l-0.1,0.3C0.1,17.2,0,17.8,0,18.5
	s0.1,1.3,0.3,1.9l0-0.1c0,0,0,0.1,0,0.1s0,0.1,0,0.1l0,0l-0.1,0.5c0,0.1,0,0.1,0,0.2c0,0.4,0.2,0.7,0.5,0.9l0,0
	c0.3,0.1,0.7,0.3,1.1,0.4l0,0c0.1,0.1,0.2,0.2,0.3,0.2l0,0C2.4,22.9,2.8,23,3.2,23c0.1,0,0.2,0,0.3,0l0,0c0.2,0,0.4,0,0.6-0.1l0,0
	c2,0.2,4.3,0.4,6.6,0.4c0.2,0,0.5,0,0.7,0h0c1.3,0,2.8,0,4.4-0.1c0.2,0,0.4-0.1,0.5-0.2l0,0c0.8,1.4,3.3,1.4,4.3,0.3
	c0.4-0.5,0.7-1,0.8-1.6l0,0c0.1,0.1,0.3,0.2,0.6,0.2c0.1,0,0.1,0,0.2,0l0,0l6.4-1.9c0.3,0.5,0.8,0.8,1.3,0.8c0.2,0,0.5-0.1,0.7-0.2
	l0,0c0.9-0.4,1.1-1.9,1.1-2.7c0-0.2,0-0.4,0-0.6s0-0.4,0-0.7l0,0c0,0,0,0,0,0c0.1,0,0.2,0,0.2-0.1l0,0L32,16.3z M21.7,21.1
	c-0.1-0.1-0.1-0.2-0.1-0.3c0,0,0,0,0,0v0c0-0.4,0.1-0.8,0.1-1.3c0-0.2,0-0.3,0-0.5v0c0-1-0.3-1.9-0.9-2.7l0,0
	c-0.3-0.5-0.9-0.8-1.5-0.8c-0.2,0-0.4,0-0.6,0.1l0,0c-0.2,0.1-0.4,0.2-0.6,0.3l0,0c-0.6,0.5-1.1,1.1-1.3,1.8l0,0
	c-0.4,1.1-0.6,2.4-0.6,3.8c0,0.3,0,0.5,0,0.8l0,0c0,0,0,0,0,0.1s0,0,0,0.1v0c0,0.2-0.2,0.3-0.3,0.3l0,0c-1.1,0-2.3,0.1-3.6,0.1
	c-2.6,0-5.3-0.1-7.8-0.4l0.3,0c-1.2-0.1-2.3-0.3-3.4-0.6l0.1,0c-0.2-0.1-0.4-0.1-0.6-0.2l0,0c-0.1-0.1-0.2-0.2-0.2-0.4
	c0,0,0-0.1,0-0.1v0l0.1-0.5c0-0.1,0-0.1,0-0.2s0-0.2,0-0.2l0,0c-0.1-0.5-0.2-1.1-0.2-1.8c0-0.5,0.1-1,0.1-1.4l0,0
	c0.2,0.1,0.5,0.2,0.8,0.2l0,0l0.4,0.1c0.8,0.1,0.9,0,0.9-0.1c0.1-0.1,0.1-0.2,0.1-0.3c0,0,0-0.1,0-0.1v0c-0.1-0.5-0.3-0.9-0.6-1.3
	l0,0c-0.2-0.2-0.4-0.5-0.6-0.6l0,0c1.8-1.2,3.9-2.1,6.2-2.4l0.1,0c0.2,0,0.3-0.1,0.4-0.2l0,0c1.8,0.4,3.9,0.6,6.1,0.6
	c1.5,0,3-0.1,4.5-0.3l-0.2,0c0.4-0.1,1.1,0,1.4-0.3c0.3-0.5,0.6-1,0.8-1.6l0-0.1c0.3-0.5,0.6-1.1,0.9-1.6c0,0,0,0,0-0.1s0,0,0-0.1
	l0,0c-1.1-0.1-2.3-0.2-3.5-0.2S15.8,8.9,14.6,9l0.2,0c1.6-0.3,3.5-0.5,5.4-0.5c1.3,0,2.5,0.1,3.7,0.2l-0.1,0c0.4,0,0.8,0.1,1.1,0.1
	h-0.5c-0.7,0-1.5,0-2,0.6c-0.5,0.8-0.9,1.6-1.2,2.5l0,0.1c0,0-0.1,0.2-0.1,0.3c0,0,0,0,0,0c0,0,0,0.1,0.1,0.1c0,0,0,0,0,0l0,0
	l0.5-0.1c-0.2-0.1-0.3-0.4-0.2-0.6c0.1-0.2,0.3-0.4,0.5-0.5l0,0c0.4-0.2,1.7-0.3,1.9,0.3c0,0.1,0.1,0.2,0.1,0.3s0,0.2-0.1,0.3l0,0
	c1.8-0.2,4-0.4,5-0.5c0,0,0.1,0,0.1-0.1c0,0,0,0,0,0l0,0c-0.5-0.8-1-1.4-1.7-2l0,0c0.7,0.5,1.3,1,1.8,1.6l0,0l0.1,0.2
	c0.2,0.2,0.3,0.4,0.6,0.5l0,0l0.4,0.2c0.2,0.1,0.4,0.2,0.6,0.3l0,0c0,0,0,0,0.1,0.2v0.1c0.1,0.3,0.1,0.5,0.2,0.7l0,0l0.1,0.3
	c0.1,0.2,0.2,0.5,0.3,0.8l0,0c0,0.1,0,0.1,0,0.2c-0.1-0.2-0.3-0.3-0.6-0.3h0c-0.3,0-0.5,0.2-0.7,0.4l0,0c-0.1,0.1-0.2,0.2-0.2,0.3
	l0,0c-0.1,0.1-0.1,0.2-0.2,0.3l0,0c-0.2,0.4-0.3,0.9-0.4,1.4l0,0C29,17.2,29,17.7,29,18.2c0,0.1,0,0.1,0,0.2v0c0,0.1,0,0.3,0,0.4
	c0,0,0,0,0,0c0,0.2-0.1,0.3-0.3,0.4l0,0l-0.3,0.1L22,21.2c0,0,0,0-0.1,0C21.8,21.2,21.8,21.1,21.7,21.1L21.7,21.1L21.7,21.1z
	 M19.2,23.2c-0.9,0-1.6-1.6-1.6-3.4s0.9-3.3,1.8-3.3S21,18,21,19.9S20.1,23.2,19.2,23.2z M31.2,17.8c-0.1,1.3-0.5,2.3-1,2.2
	s-0.7-1.2-0.6-2.5s0.6-2.3,1-2.2S31.4,16.5,31.2,17.8z"
      />
      <path
        d="M25.6,14.2l0.5-0.1c0.1,0,0.1-0.1,0.1-0.1c0-0.1-0.1-0.1-0.1-0.1c0,0,0,0,0,0h0L25.6,14c-0.1,0-0.1,0.1-0.1,0.1
	c0,0,0,0,0,0v0C25.5,14.2,25.5,14.2,25.6,14.2C25.6,14.2,25.6,14.2,25.6,14.2L25.6,14.2L25.6,14.2z"
      />
      <path
        d="M28.8,13.8l0.5-0.1c0.1,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0v0c0,0,0,0,0,0c0-0.1-0.1-0.1-0.1-0.1c0,0,0,0,0,0h0
	l-0.5,0.1c-0.1,0-0.1,0.1-0.1,0.2c0,0,0,0,0,0l0,0C28.7,13.7,28.7,13.8,28.8,13.8C28.8,13.8,28.8,13.8,28.8,13.8
	C28.8,13.8,28.8,13.8,28.8,13.8z"
      />
      <path
        d="M9.3,19.7l-4.4-0.3l-2.4-0.1c-0.4,0-0.6,0.2-0.5,0.6s0.8,0.7,1.7,0.8l1.2,0.1L8.4,21c1,0.1,1.5-0.2,1.5-0.5
	c0,0,0,0,0-0.1C10,20,9.7,19.7,9.3,19.7C9.3,19.7,9.3,19.7,9.3,19.7C9.3,19.7,9.3,19.7,9.3,19.7z"
      />
      <path
        d="M15,15.3c-0.5,0-1,0.2-1.5,0.4l0,0c-1.6,0.7-2.2,1.9-2,2.1c0.3,0.1,0.6,0.1,0.9,0.1c0.1,0,0.2,0,0.3,0l0,0
	c0.1,0,0.2,0,0.3,0c0.8,0,1.5-0.1,2.2-0.4l0,0c0.3-0.3,0.5-0.8,0.5-1.3c0-0.3-0.1-0.6-0.2-0.8l0,0C15.4,15.3,15.2,15.3,15,15.3
	C15.1,15.3,15,15.3,15,15.3L15,15.3L15,15.3z"
      />
    </SvgIcon>
  );
}

export function CarDriverBackIcon() {
  return (
    <SvgIcon viewBox="0 0 40 27">
      <title>Car Driver Back Icon</title>
      <path
        d="M25.3,14.3l2-0.1c0.1,0,0.1,0.1,0.1,0.1v1c0,0,0,0,0,0c0,0.1-0.1,0.1-0.1,0.1l0,0l-2,0.2
	c-0.1,0-0.1-0.1-0.1-0.1v-1c0,0,0,0,0,0C25.1,14.4,25.2,14.3,25.3,14.3L25.3,14.3L25.3,14.3z"
      />
      <path
        d="M12.6,14.4H12c-0.1,0-0.2,0.1-0.2,0.2c0,0,0,0,0,0v0c0,0.1,0.1,0.2,0.2,0.2l0,0l0,0h0.7c0.1,0,0.2-0.1,0.2-0.2
	l0,0C12.8,14.5,12.8,14.4,12.6,14.4L12.6,14.4L12.6,14.4L12.6,14.4z"
      />
      <path
        d="M7.8,14.3H7.2c-0.1,0-0.2,0.1-0.2,0.2c0,0,0,0,0,0v0c0,0.1,0.1,0.2,0.2,0.2l0,0h0.7c0.1,0,0.2-0.1,0.2-0.2v0
	l0,0l0,0C8,14.4,7.9,14.3,7.8,14.3L7.8,14.3L7.8,14.3z"
      />
      <path
        d="M19.2,15.7C19.2,15.7,19.2,15.7,19.2,15.7c-0.2,0-0.3,0-0.4-0.1l0,0c-0.2-0.3-0.9-1.5-0.3-1.7
	c0.6-0.1,1.4-0.1,2.1-0.1c0.5,0,1,0,1.5,0.1l-0.1,0c0.4,0,0.7,0.1,1,0.2l0,0c0.2,0.2-0.3,0.6-0.4,0.7c-0.5,0.5-1.2,0.8-1.9,0.9l0,0
	c-0.4,0.1-0.9,0.1-1.4,0.1C19.4,15.7,19.3,15.7,19.2,15.7L19.2,15.7L19.2,15.7z"
      />
      <path d="M4.4,12.4v0.1c0,0,0,0.1,0,0.1s0,0.1,0,0.1l0,0L4.4,12.4z" />
      <path d="M27.1,11.4C27.1,11.4,27.1,11.4,27.1,11.4C27.2,11.4,27.2,11.3,27.1,11.4L27.1,11.4L27.1,11.4z" />
      <path
        d="M31.9,17.1c0-0.3-0.1-0.5-0.3-0.7l0,0c-0.1-0.2-0.2-0.4-0.3-0.6l0,0c0-0.1-0.1-0.2-0.1-0.3v0
	c0-0.4-0.1-0.8-0.2-1.1l0,0L31,14l-0.2,0.1c0-0.2-0.1-0.4-0.1-0.5H31l-0.2-0.7c0,0,0-0.1,0-0.1s0-0.1,0-0.1v0c0-0.4-0.3-0.8-0.7-0.9
	l0,0c-0.6-0.1-1-0.3-1.5-0.6l0,0c-0.5-0.2-0.8-0.5-1.2-0.7l0,0c-0.3-0.2-0.7-0.4-1-0.6l-0.1,0L26,9.7c-0.7-0.4-1.4-0.7-2.3-1l-0.1,0
	c-0.8-0.2-1.8-0.4-2.8-0.5l-0.1,0c-1.2-0.1-2.6-0.2-4-0.2S14,8.1,12.6,8.2l0.2,0h-0.5C11,8.3,9.8,8.6,8.8,9l0.1,0
	c-1.4,0.7-2.6,1.5-3.7,2.6l0,0c-0.3,0.1-0.6,0.3-0.8,0.5l0,0c0,0,0,0,0,0s0,0,0,0v0l-1.7,0.6c-0.5,0.2-0.9,0.3-1,0.4
	c-0.7,0.5-1.2,1.2-1.4,2.1l0,0C0.1,16,0,16.8,0,17.7c0,0.1,0,0.2,0,0.3v0l0.1,1.1c0,0.2,0.1,0.4,0.3,0.5l0,0c0.1,0,0.1,0.1,0.2,0.1
	s0.2,0,0.2-0.1l0,0c0,0,0.1-0.1,0.1-0.1l0,0c0.1,0.4,0.3,0.8,0.6,1.1l0,0c0.4,0.4,0.9,0.7,1.5,0.7c0.2,0,0.4,0,0.5-0.1l0,0
	c0.4-0.1,0.8-0.3,1-0.7l0,0l7.6,1.1c0,0,0,0,0,0c0.1,0,0.3-0.1,0.4-0.2l0,0c0.4,1.4,1.2,2.5,2.7,2.5c0,0,0.1,0,0.1,0
	c1.1,0,2-0.7,2.3-1.7l0,0v-0.1c0.9,0,2.4-0.1,3-0.1h0.2c0.6,0,2.6-0.3,4.6-0.6c0.4,0.6,1.1,1.1,1.9,1.2l0,0c1.1,0.1,1.7-0.8,2.1-1.8
	l1.1-0.2l1.1-0.5c0.1-0.1,0.3-0.2,0.3-0.4l0,0c0.2-0.6,0.3-1.2,0.3-1.9C32,17.6,32,17.3,31.9,17.1L31.9,17.1L31.9,17.1z M4.4,12.4
	c0-0.1,0.1-0.2,0.2-0.3l0,0c0.2-0.1,0.4-0.2,0.6-0.3l0,0c0,0,0.1,0,0.1,0c0.2,0,0.3,0.1,0.4,0.3l0,0l0.1,0.3c0,0,0,0.1,0,0.1
	s0,0.1,0,0.1v0v0.1L5,13.1l-0.4-0.1c-0.1-0.1-0.2-0.1-0.2-0.2l0,0c0,0,0-0.1,0-0.1s0-0.1,0-0.1l0,0L4.4,12.4z M2.1,20.3
	c-0.5,0.1-1-0.9-1.1-2.1s0.2-2.3,0.7-2.4s1,0.9,1.2,2.1S2.6,20.2,2.1,20.3z M14.5,22.9c-0.7,0.1-1.4-1.1-1.6-2.6s0.4-2.8,1.1-2.9
	s1.4,1.1,1.6,2.6S15.2,22.8,14.5,22.9z M22.3,21c-0.1,0.2-0.3,0.3-0.5,0.2s-0.2-0.4,0-0.6s0.3-0.4,0.5-0.2S22.5,20.8,22.3,21z
	 M23.1,20.9c-0.1,0.2-0.3,0.4-0.5,0.2s-0.2-0.4,0-0.6s0.3-0.4,0.5-0.2S23.2,20.7,23.1,20.9z M30.2,18.9c-0.3,0-0.5,0.2-0.6,0.3l0,0
	l-5,0.6h-0.1c-0.5-0.3-0.8-0.2-0.8-0.2l-2.4,0.3c-0.1,0-0.1,0-0.2,0s-0.1,0-0.2,0l0,0c-0.3,0.1-0.6,0.2-0.8,0.4l0,0
	c-0.3,0.2-0.5,0.5-0.6,0.9l0,0l-0.1,0.1c-0.6,0-1.3,0.1-1.9,0.1h-0.2c0,0,0,0,0,0c-0.2,0-0.3-0.1-0.5-0.2l0,0c0-0.1-0.1-0.1-0.1-0.2
	l0,0c0-0.1,0-0.2,0-0.2c0-1.5-0.5-2.9-1.3-4l0,0c-0.3-0.4-0.9-0.7-1.5-0.7h0h-0.1c-0.6,0-1.2,0.3-1.5,0.8l0,0
	c-0.4,0.8-0.7,1.8-0.7,2.9c0,0.4,0,0.8,0.1,1.2l0,0l-8.1-1c0-0.1,0-0.1,0-0.2s0-0.1,0-0.2l0,0c0-0.1,0-0.1,0-0.2
	c0-1.4-0.5-2.7-1.2-3.8l0,0c-0.1-0.2-0.2-0.3-0.4-0.5l0,0c-0.2-0.2-0.4-0.3-0.6-0.3c-0.2,0-0.4,0.1-0.5,0.2l0,0
	c0.2-0.4,0.4-0.8,0.8-1l0,0l0.9-0.3L4.3,13c0,0.1,0.1,0.1,0.2,0.1l0,0l0.6,0.2l0.1,0.3c0,0.1,0.1,0.1,0.1,0.1c0,0,0,0,0,0l0,0
	c0.1,0,0.2,0,0.2-0.1l0,0l0.2-0.4c0.1-0.1,0.1-0.2,0.1-0.3c0,0,0,0,0,0l0,0v-0.1c2.1-0.1,7.5-0.4,9.9-0.2c0.4,0,0.1-0.5,0-0.7
	c-0.5-0.8-1-1.5-1.7-2.1l0,0c-0.7-0.3-1.5-0.6-2.3-0.6c-0.2,0-0.5,0-0.7,0l0,0h-0.2c0.5-0.1,1.1-0.1,1.6-0.2l0.5,0
	c1.2-0.1,2.5-0.2,3.9-0.2s2.7,0.1,4.1,0.2l-0.2,0c0.8,0.1,1.5,0.2,2.2,0.4l-0.1,0c-0.9-0.1-1.9-0.1-3-0.1s-2.1,0.1-3.1,0.2l0.1,0
	c-0.5,0.1-0.9,0.1-1.2,0.2l0.1,0c0,0-0.1,0.1-0.1,0.1s0,0.1,0.1,0.1l0,0c0.4,0.3,1.2,1,2.5,2c0.1,0.1,0.3,0.2,0.5,0.2l0,0
	c2.5-0.3,5.4-0.6,8.4-0.6l0.1,0c0,0,0,0,0,0c0,0,0.1,0,0.1-0.1v0c0.3,0.2,0.7,0.4,1,0.6l0.1,0c0.4,0.2,1,0.4,1.5,0.6l0.1,0
	c0,0,0.2,0.1,0.2,0.2c0,0,0,0.1,0,0.1s0,0.1,0,0.1v0c-0.5,0.1-0.9,0.1-1.3,0.3l0.1,0c-0.5,0.2-0.6,0.3-0.7,0.4c0,0.1,0,0.1,0,0.2
	s0,0.1,0,0.2l0,0c0.3,0.5,0.8,0.9,1.4,1l0,0c0.1,0,0.3,0,0.5,0s0.4,0,0.5,0l0,0c0,0.3,0.1,0.5,0.1,0.6c0,0.2,0,0.4,0.1,0.6l0,0
	c0.1,0.3,0.2,0.5,0.4,0.8l0,0c0.1,0.1,0.1,0.2,0.1,0.3v0c0,0.2,0.1,0.5,0.1,0.8s0,0.6-0.1,0.8l0,0C30.9,18.8,30.2,19,30.2,18.9
	L30.2,18.9z M31.5,19.8c-0.1,0.2-0.3,0.3-0.4,0.2s-0.1-0.3-0.1-0.5s0.3-0.3,0.4-0.2S31.6,19.6,31.5,19.8L31.5,19.8z"
      />
    </SvgIcon>
  );
}

export function DamageIcon() {
  return (
    <SvgIcon viewBox="0 0 40 27">
      <title>Damage Icon</title>
      <path
        d="M32,20.6l-8-5.7l4.8-8.6l-9.3,2.9L16,0l-3.5,9.2L3.2,6.3L8,14.9l-8,5.7l9.6,1.5L8.9,32l7.1-6.7l7.1,6.7
	l-0.7-9.9L32,20.6z M17.4,23.8L16,22.5l-1.4,1.3L11.3,27l0.3-4.8l0.1-1.8l-1.8-0.3l-4.8-0.8l4-2.8l1.5-1L9.8,14L7.4,9.7l6.3,2
	l0.7-1.8L16,5.6l1.7,4.3l0.7,1.8l1.8-0.6l4.5-1.4L22.2,14l-0.9,1.6l1.5,1l4,2.8l-6.6,1l0.1,1.8l0.3,4.8L17.4,23.8z"
      />
    </SvgIcon>
  );
}

export function OdometerIcon() {
  return (
    <SvgIcon viewBox="0 0 40 27">
      <title>Odometer Icon</title>
      <path
        d="M6.4,12.8c0,0-0.1,0-0.1,0c-0.6,0-1.2,0.3-1.6,0.8l0,0c-0.4,0.6-0.6,1.4-0.6,2.2c0,0.1,0,0.2,0,0.4l0,0
	c0,0.1,0,0.2,0,0.3c0,0.8,0.2,1.5,0.6,2.2l0,0c0.3,0.5,0.9,0.8,1.6,0.8c0,0,0.1,0,0.1,0h0c0,0,0.1,0,0.1,0c0.6,0,1.2-0.3,1.6-0.8
	l0,0c0.4-0.6,0.6-1.4,0.6-2.2c0-0.1,0-0.2,0-0.3l0,0c0-0.1,0-0.1,0-0.2c0-0.8-0.2-1.6-0.6-2.3l0,0C7.7,13.1,7.1,12.8,6.4,12.8
	C6.4,12.8,6.4,12.8,6.4,12.8L6.4,12.8L6.4,12.8z M7,17.8c-0.1,0.3-0.4,0.5-0.7,0.5s-0.6-0.2-0.7-0.5l0,0c-0.1-0.4-0.2-0.9-0.2-1.4
	c0-0.1,0-0.2,0-0.3l0,0c0-0.1,0-0.2,0-0.2c0-0.5,0.1-1,0.2-1.5l0,0c0.1-0.3,0.4-0.5,0.7-0.5s0.6,0.2,0.7,0.5l0,0
	c0.1,0.4,0.2,0.9,0.2,1.5c0,0.1,0,0.2,0,0.3v0c0,0,0,0.1,0,0.2C7.2,16.8,7.2,17.3,7,17.8L7,17.8L7,17.8z"
      />
      <path
        d="M13.2,13.6c-0.3-0.5-0.9-0.8-1.6-0.8c0,0-0.1,0-0.1,0h0c0,0-0.1,0-0.1,0c-0.6,0-1.2,0.3-1.6,0.8l0,0
	c-0.4,0.6-0.6,1.4-0.6,2.2c0,0.1,0,0.2,0,0.3l0,0c0,0.1,0,0.2,0,0.3c0,0.8,0.2,1.6,0.6,2.2l0,0c0.3,0.5,0.9,0.8,1.6,0.8
	c0,0,0.1,0,0.1,0h0c0,0,0.1,0,0.1,0c0.6,0,1.2-0.3,1.6-0.8l0,0c0.4-0.6,0.6-1.4,0.6-2.2c0-0.1,0-0.2,0-0.3l0,0c0-0.1,0-0.2,0-0.3
	C13.8,15,13.5,14.3,13.2,13.6L13.2,13.6L13.2,13.6z M12.2,17.8c-0.1,0.3-0.4,0.5-0.7,0.5l0,0c0,0,0,0,0,0c-0.3,0-0.6-0.2-0.7-0.5
	l0,0c-0.1-0.4-0.2-0.9-0.2-1.4c0-0.1,0-0.2,0-0.3l0,0c0-0.1,0-0.2,0-0.2c0-0.5,0.1-1,0.2-1.5l0,0c0.1-0.3,0.4-0.5,0.7-0.5
	s0.6,0.2,0.7,0.5l0,0c0.1,0.4,0.2,0.9,0.2,1.5c0,0.1,0,0.2,0,0.3l0,0c0,0.1,0,0.2,0,0.3C12.4,16.9,12.3,17.4,12.2,17.8
	C12.2,17.8,12.2,17.8,12.2,17.8z"
      />
      <path
        d="M16.6,12.8c0,0-0.1,0-0.1,0c-0.6,0-1.2,0.3-1.6,0.8l0,0c-0.4,0.6-0.6,1.4-0.6,2.2c0,0.1,0,0.2,0,0.4l0,0
	c0,0.1,0,0.1,0,0.2c0,0.8,0.2,1.6,0.6,2.3l0,0c0.3,0.5,0.9,0.8,1.6,0.8c0,0,0.1,0,0.1,0h0c0,0,0.1,0,0.1,0c0.6,0,1.2-0.3,1.6-0.8
	l0,0c0.4-0.6,0.6-1.4,0.6-2.2c0-0.1,0-0.2,0-0.3l0,0c0-0.1,0-0.2,0-0.3c0-0.8-0.2-1.6-0.6-2.2l0,0c-0.3-0.5-0.9-0.8-1.6-0.8
	C16.7,12.8,16.7,12.8,16.6,12.8L16.6,12.8L16.6,12.8z M17.3,17.8c-0.1,0.3-0.4,0.5-0.7,0.5s-0.6-0.2-0.7-0.5l0,0
	c-0.1-0.4-0.2-0.9-0.2-1.5c0-0.1,0-0.2,0-0.3v0c0-0.1,0-0.2,0-0.2c0-0.5,0.1-1,0.2-1.5l0,0c0.1-0.3,0.4-0.5,0.7-0.5c0,0,0,0,0,0l0,0
	h0c0.3,0,0.6,0.2,0.7,0.5l0,0c0.1,0.4,0.2,0.9,0.2,1.5c0,0.1,0,0.2,0,0.3v0c0,0.1,0,0.2,0,0.3C17.5,16.9,17.5,17.4,17.3,17.8
	L17.3,17.8L17.3,17.8z"
      />
      <path
        d="M28.1,7.6H3.9c0,0,0,0,0,0C1.7,7.6,0,9.3,0,11.4l0,0l0,0v9.3c0,2.1,1.7,3.9,3.9,3.9l0,0h24.3
	c2.1,0,3.9-1.7,3.9-3.9l0,0v-9.3l0,0C32,9.3,30.3,7.6,28.1,7.6C28.1,7.6,28.1,7.6,28.1,7.6C28.1,7.6,28.1,7.6,28.1,7.6z M27.1,9.6
	c0,0.2,0,0.4,0,0.5c0,0.4-0.1,0.9-0.2,1.3l0,0c-0.1,0.3-0.4,0.5-0.7,0.5l0,0c0,0,0,0,0,0c-0.3,0-0.6-0.2-0.7-0.5l0,0
	c-0.1-0.4-0.2-1-0.2-1.5c0-0.1,0-0.2,0-0.3l0,0L27.1,9.6z M21,22.6H3.9c-1,0-1.9-0.8-1.9-1.9l0,0v-9.3l0,0c0-1,0.8-1.9,1.8-1.9
	c0,0,0,0,0,0H21V22.6z M30,20.7c0,1-0.9,1.9-1.9,1.9c0,0,0,0-0.1,0h0h-1v-6h-0.7l-2.1,2l0.6,0.8l1.1-0.9v4.1h-4v-13h2
	c0,0,0,0.1,0,0.1c0,0.1,0,0.2,0,0.3c0,0.8,0.2,1.5,0.6,2.2l0,0c0.3,0.5,0.9,0.8,1.6,0.8c0,0,0.1,0,0.1,0h0c0,0,0.1,0,0.1,0
	c0.6,0,1.2-0.3,1.6-0.8l0,0c0.4-0.6,0.6-1.4,0.6-2.2c0-0.1,0-0.2,0-0.3l0,0c0.8,0.2,1.5,0.9,1.5,1.7v0L30,20.7z"
      />
    </SvgIcon>
  );
}

export function VinIcon() {
  return (
    <SvgIcon viewBox="0 0 40 27">
      <title>VIN Icon</title>
      <path
        d="M4.9,8h0.2c0,0,0,0,0,0C5.6,8,6,8.4,6,8.9v0v14.2C6,23.6,5.6,24,5.1,24c0,0,0,0,0,0H4.9c0,0,0,0,0,0
	C4.4,24,4,23.6,4,23.1v0V8.9C4,8.4,4.4,8,4.9,8C4.9,8,4.9,8,4.9,8L4.9,8z"
      />
      <path
        d="M8.6,8h0.1c0,0,0,0,0,0c0.5,0,0.9,0.4,0.9,0.9v0v8c0,0.5-0.4,0.9-0.9,0.9c0,0,0,0,0,0H8.6c0,0,0,0,0,0
	c-0.5,0-0.9-0.4-0.9-0.9v0v-8C7.7,8.4,8.1,8,8.6,8C8.6,8,8.6,8,8.6,8C8.6,8,8.6,8,8.6,8z"
      />
      <path
        d="M12.2,8h0.2c0,0,0,0,0,0c0.5,0,0.9,0.4,0.9,0.9v8c0,0.5-0.4,0.9-0.9,0.9c0,0,0,0,0,0h-0.2c0,0,0,0,0,0
	c-0.5,0-0.9-0.4-0.9-0.9v-8C11.3,8.4,11.7,8,12.2,8C12.2,8,12.2,8,12.2,8C12.3,8,12.2,8,12.2,8z"
      />
      <path
        d="M15.9,8h0.2c0,0,0,0,0,0C16.6,8,17,8.4,17,8.9v8c0,0.5-0.4,0.9-0.9,0.9c0,0,0,0,0,0h-0.2c0,0,0,0,0,0
	c-0.5,0-0.9-0.4-0.9-0.9v-8C15,8.4,15.4,8,15.9,8C15.9,8,15.9,8,15.9,8C15.9,8,15.9,8,15.9,8z"
      />
      <path
        d="M19.6,8h0.2c0,0,0,0,0,0c0.5,0,0.9,0.4,0.9,0.9v8c0,0.5-0.4,0.9-0.9,0.9c0,0,0,0,0,0h-0.2c0,0,0,0,0,0
	c-0.5,0-0.9-0.4-0.9-0.9v-8C18.7,8.4,19.1,8,19.6,8C19.6,8,19.6,8,19.6,8L19.6,8z"
      />
      <path
        d="M23.3,8h0.1c0,0,0,0,0,0c0.5,0,0.9,0.4,0.9,0.9v0v8c0,0.5-0.4,0.9-0.9,0.9c0,0,0,0,0,0h-0.1c0,0,0,0,0,0
	c-0.5,0-0.9-0.4-0.9-0.9v0v-8C22.4,8.4,22.8,8,23.3,8C23.3,8,23.3,8,23.3,8C23.3,8,23.3,8,23.3,8z"
      />
      <path
        d="M26.9,8h0.1c0,0,0,0,0,0C27.6,8,28,8.4,28,8.9v0v14.2c0,0.5-0.4,0.9-0.9,0.9c0,0,0,0,0,0h-0.1c0,0,0,0,0,0
	c-0.5,0-0.9-0.4-0.9-0.9v0V8.9C26,8.4,26.4,8,26.9,8C26.9,8,26.9,8,26.9,8L26.9,8z"
      />
      <path
        d="M10.8,22.9v-1.1c0,0,0,0,0,0c0-0.1,0.1-0.2,0.2-0.2c0,0,0,0,0,0h0c0.2,0,0.3,0.1,0.3,0.3v1.3c0,0,0,0,0,0
	c0,0.1-0.1,0.2-0.2,0.2c0,0,0,0,0,0h0H8.9c-0.1,0-0.3-0.1-0.3-0.3s0.1-0.3,0.3-0.3h0.8v-3.1H8.9c0,0,0,0,0,0c-0.1,0-0.2-0.1-0.2-0.2
	c0,0,0,0,0,0v0c0,0,0,0,0,0c0-0.1,0.1-0.2,0.2-0.2c0,0,0,0,0,0h0h1.4v3.6L10.8,22.9z"
      />
      <path
        d="M13.1,22.9H15c0.1,0,0.3,0.1,0.3,0.3s-0.1,0.3-0.3,0.3h-2.4v-1.7c0,0,0,0,0-0.1c0-0.3,0.2-0.5,0.5-0.5
	c0,0,0.1,0,0.1,0h0h1.6v-1.3h-1.9c0,0,0,0,0,0c-0.1,0-0.2-0.1-0.2-0.2c0,0,0,0,0,0v0c0,0,0,0,0,0c0-0.1,0.1-0.2,0.2-0.2c0,0,0,0,0,0
	h0h1.8c0,0,0,0,0,0c0.2,0,0.3,0.1,0.4,0.2h0c0.1,0.1,0.2,0.2,0.2,0.4c0,0,0,0,0,0.1v0V21c0,0,0,0,0,0.1c0,0.2-0.1,0.3-0.2,0.4l0,0
	c-0.1,0.1-0.2,0.2-0.4,0.2c0,0,0,0,0,0h0h-1.6L13.1,22.9z"
      />
      <path
        d="M16.8,19.8C16.8,19.8,16.8,19.8,16.8,19.8c-0.2,0-0.3-0.1-0.3-0.2c0,0,0,0,0,0v0c0,0,0,0,0,0
	c0-0.1,0.1-0.2,0.2-0.2c0,0,0,0,0,0h0h1.9c0,0,0,0,0,0c0.3,0,0.5,0.2,0.5,0.5l0,0l0,0v1c0,0,0,0,0,0.1c0,0.2-0.1,0.3-0.2,0.5l0,0
	c0.1,0.1,0.2,0.3,0.2,0.5c0,0,0,0,0,0.1v0v1c0,0,0,0,0,0c0,0.3-0.2,0.5-0.5,0.5c0,0,0,0,0,0h0h-1.9c-0.1,0-0.3-0.1-0.3-0.3
	s0.1-0.3,0.3-0.3h1.9V22c0-0.3-0.1-0.4-0.3-0.4h-1.1c0,0,0,0-0.1,0c-0.1,0-0.3-0.1-0.3-0.3s0.1-0.3,0.3-0.3c0,0,0,0,0.1,0h0h1.1
	c0.1,0,0.3-0.1,0.3-0.4v-0.9L16.8,19.8z"
      />
      <path
        d="M22.4,21.5V20c0,0,0,0,0,0c0-0.1,0.1-0.2,0.2-0.2c0,0,0,0,0,0h0c0,0,0,0,0.1,0c0.1,0,0.2,0.1,0.2,0.2
	c0,0,0,0,0,0v0v1.5c0,0,0,0,0.1,0c0.1,0,0.3,0.1,0.3,0.3s-0.1,0.3-0.3,0.3c0,0,0,0-0.1,0h0v1.1c0,0,0,0,0,0c0,0.1-0.1,0.2-0.2,0.2
	c0,0,0,0,0,0h0c-0.2,0-0.3-0.1-0.3-0.3v-1.1h-1.7v-2.5c0,0,0,0,0,0c0-0.1,0.1-0.2,0.2-0.2c0,0,0,0,0,0h0c0,0,0,0,0,0
	c0.1,0,0.2,0.1,0.2,0.2c0,0,0,0,0,0v0v2L22.4,21.5z"
      />
      <path
        d="M4.9,8h0.2c0,0,0,0,0,0C5.6,8,6,8.4,6,8.9v0v14.2C6,23.6,5.6,24,5.1,24c0,0,0,0,0,0H4.9c0,0,0,0,0,0
	C4.4,24,4,23.6,4,23.1v0V8.9C4,8.4,4.4,8,4.9,8C4.9,8,4.9,8,4.9,8L4.9,8z"
      />
      <path
        d="M8.6,8h0.1c0,0,0,0,0,0c0.5,0,0.9,0.4,0.9,0.9v0v8c0,0.5-0.4,0.9-0.9,0.9c0,0,0,0,0,0H8.6c0,0,0,0,0,0
	c-0.5,0-0.9-0.4-0.9-0.9v0v-8C7.7,8.4,8.1,8,8.6,8C8.6,8,8.6,8,8.6,8C8.6,8,8.6,8,8.6,8z"
      />
      <path
        d="M12.2,8h0.2c0,0,0,0,0,0c0.5,0,0.9,0.4,0.9,0.9v8c0,0.5-0.4,0.9-0.9,0.9c0,0,0,0,0,0h-0.2c0,0,0,0,0,0
	c-0.5,0-0.9-0.4-0.9-0.9v-8C11.3,8.4,11.7,8,12.2,8C12.2,8,12.2,8,12.2,8C12.3,8,12.2,8,12.2,8z"
      />
      <path
        d="M15.9,8h0.2c0,0,0,0,0,0C16.6,8,17,8.4,17,8.9v8c0,0.5-0.4,0.9-0.9,0.9c0,0,0,0,0,0h-0.2c0,0,0,0,0,0
	c-0.5,0-0.9-0.4-0.9-0.9v-8C15,8.4,15.4,8,15.9,8C15.9,8,15.9,8,15.9,8C15.9,8,15.9,8,15.9,8z"
      />
      <path
        d="M19.6,8h0.2c0,0,0,0,0,0c0.5,0,0.9,0.4,0.9,0.9v8c0,0.5-0.4,0.9-0.9,0.9c0,0,0,0,0,0h-0.2c0,0,0,0,0,0
	c-0.5,0-0.9-0.4-0.9-0.9v-8C18.7,8.4,19.1,8,19.6,8C19.6,8,19.6,8,19.6,8L19.6,8z"
      />
      <path
        d="M23.3,8h0.1c0,0,0,0,0,0c0.5,0,0.9,0.4,0.9,0.9v0v8c0,0.5-0.4,0.9-0.9,0.9c0,0,0,0,0,0h-0.1c0,0,0,0,0,0
	c-0.5,0-0.9-0.4-0.9-0.9v0v-8C22.4,8.4,22.8,8,23.3,8C23.3,8,23.3,8,23.3,8C23.3,8,23.3,8,23.3,8z"
      />
      <path
        d="M26.9,8h0.1c0,0,0,0,0,0C27.6,8,28,8.4,28,8.9v0v14.2c0,0.5-0.4,0.9-0.9,0.9c0,0,0,0,0,0h-0.1c0,0,0,0,0,0
	c-0.5,0-0.9-0.4-0.9-0.9v0V8.9C26,8.4,26.4,8,26.9,8C26.9,8,26.9,8,26.9,8L26.9,8z"
      />
      <path
        d="M10.8,22.9v-1.1c0,0,0,0,0,0c0-0.1,0.1-0.2,0.2-0.2c0,0,0,0,0,0h0c0.2,0,0.3,0.1,0.3,0.3v1.3c0,0,0,0,0,0
	c0,0.1-0.1,0.2-0.2,0.2c0,0,0,0,0,0h0H8.9c-0.1,0-0.3-0.1-0.3-0.3s0.1-0.3,0.3-0.3h0.8v-3.1H8.9c0,0,0,0,0,0c-0.1,0-0.2-0.1-0.2-0.2
	c0,0,0,0,0,0v0c0,0,0,0,0,0c0-0.1,0.1-0.2,0.2-0.2c0,0,0,0,0,0h0h1.4v3.6L10.8,22.9z"
      />
      <path
        d="M13.1,22.9H15c0.1,0,0.3,0.1,0.3,0.3s-0.1,0.3-0.3,0.3h-2.4v-1.7c0,0,0,0,0-0.1c0-0.3,0.2-0.5,0.5-0.5
	c0,0,0.1,0,0.1,0h0h1.6v-1.3h-1.9c0,0,0,0,0,0c-0.1,0-0.2-0.1-0.2-0.2c0,0,0,0,0,0v0c0,0,0,0,0,0c0-0.1,0.1-0.2,0.2-0.2c0,0,0,0,0,0
	h0h1.8c0,0,0,0,0,0c0.2,0,0.3,0.1,0.4,0.2h0c0.1,0.1,0.2,0.2,0.2,0.4c0,0,0,0,0,0.1v0V21c0,0,0,0,0,0.1c0,0.2-0.1,0.3-0.2,0.4l0,0
	c-0.1,0.1-0.2,0.2-0.4,0.2c0,0,0,0,0,0h0h-1.6L13.1,22.9z"
      />
      <path
        d="M16.8,19.8C16.8,19.8,16.8,19.8,16.8,19.8c-0.2,0-0.3-0.1-0.3-0.2c0,0,0,0,0,0v0c0,0,0,0,0,0
	c0-0.1,0.1-0.2,0.2-0.2c0,0,0,0,0,0h0h1.9c0,0,0,0,0,0c0.3,0,0.5,0.2,0.5,0.5l0,0l0,0v1c0,0,0,0,0,0.1c0,0.2-0.1,0.3-0.2,0.5l0,0
	c0.1,0.1,0.2,0.3,0.2,0.5c0,0,0,0,0,0.1v0v1c0,0,0,0,0,0c0,0.3-0.2,0.5-0.5,0.5c0,0,0,0,0,0h0h-1.9c-0.1,0-0.3-0.1-0.3-0.3
	s0.1-0.3,0.3-0.3h1.9V22c0-0.3-0.1-0.4-0.3-0.4h-1.1c0,0,0,0-0.1,0c-0.1,0-0.3-0.1-0.3-0.3s0.1-0.3,0.3-0.3c0,0,0,0,0.1,0h0h1.1
	c0.1,0,0.3-0.1,0.3-0.4v-0.9L16.8,19.8z"
      />
      <path
        d="M22.4,21.5V20c0,0,0,0,0,0c0-0.1,0.1-0.2,0.2-0.2c0,0,0,0,0,0h0c0,0,0,0,0.1,0c0.1,0,0.2,0.1,0.2,0.2
	c0,0,0,0,0,0v0v1.5c0,0,0,0,0.1,0c0.1,0,0.3,0.1,0.3,0.3s-0.1,0.3-0.3,0.3c0,0,0,0-0.1,0h0v1.1c0,0,0,0,0,0c0,0.1-0.1,0.2-0.2,0.2
	c0,0,0,0,0,0h0c-0.2,0-0.3-0.1-0.3-0.3v-1.1h-1.7v-2.5c0,0,0,0,0,0c0-0.1,0.1-0.2,0.2-0.2c0,0,0,0,0,0h0c0,0,0,0,0,0
	c0.1,0,0.2,0.1,0.2,0.2c0,0,0,0,0,0v0v2L22.4,21.5z"
      />
    </SvgIcon>
  );
}

export function CameraIcon() {
  return (
    <SvgIcon viewBox="0 0 40 27">
      <title>Camera Icon</title>
      <path
        d="M28,7h-5l-1.4-2.1c-0.4-0.6-1-0.9-1.7-0.9H12c-0.7,0-1.3,0.3-1.7,0.9L9,7H4C2.9,7,2,7.9,2,9v17c0,1.1,0.9,2,2,2
	h24c1.1,0,2-0.9,2-2V9C30,7.9,29.1,7,28,7z M6,12c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S6.6,12,6,12z M16,24c-3.9,0-7-3.1-7-7
	s3.1-7,7-7s7,3.1,7,7S19.9,24,16,24z"
      />
      <path d="M21,17c0,2.8-2.2,5-5,5s-5-2.2-5-5s2.2-5,5-5S21,14.2,21,17z" />
    </SvgIcon>
  );
}

export function CarPassengerFrontIcon() {
  return (
    <SvgIcon viewBox="0 0 40 27">
      <title>Car Passenger Front Icon</title>
      <path
        d="M3.3,13.9L3.3,13.9C3.3,14,3.3,14,3.2,14c0,0,0,0,0,0h0l-0.5-0.1c-0.1,0-0.1-0.1-0.1-0.1c0,0,0,0,0,0v0
	c0-0.1,0.1-0.1,0.1-0.1c0,0,0,0,0,0l0,0l0.5,0.1C3.3,13.8,3.4,13.8,3.3,13.9C3.4,13.9,3.4,13.9,3.3,13.9L3.3,13.9L3.3,13.9z
	 M6.5,14.3L6.5,14.3c0,0.1-0.1,0.1-0.1,0.1c0,0,0,0,0,0l0,0l-0.5-0.1c-0.1,0-0.1-0.1-0.1-0.1s0.1-0.1,0.1-0.1l0,0l0.5,0.1
	c0,0,0,0,0,0C6.5,14.2,6.5,14.2,6.5,14.3C6.5,14.3,6.5,14.3,6.5,14.3L6.5,14.3L6.5,14.3z M20.5,18c-0.3,0.1-0.6,0.1-0.9,0.1
	c-0.1,0-0.2,0-0.3,0l0,0c-0.1,0-0.2,0-0.3,0c-0.8,0-1.5-0.1-2.2-0.4l0,0c-0.3-0.3-0.5-0.8-0.5-1.3c0-0.3,0.1-0.6,0.2-0.8l0,0
	c0.1-0.1,0.2-0.1,0.3-0.1c0,0,0,0,0.1,0h0c0.5,0,1,0.2,1.5,0.4l0,0C20.1,16.6,20.7,17.8,20.5,18L20.5,18z"
      />
      <path
        d="M10.4,19.2c0,0.1,0,0.3,0,0.5c0,0.5,0,0.9,0.1,1.4l0-0.1c0-0.3-0.1-0.6-0.1-0.9v0c0-0.1,0-0.2,0-0.2
	C10.3,19.6,10.3,19.4,10.4,19.2C10.4,19.2,10.4,19.2,10.4,19.2z"
      />
      <path
        d="M31.8,20.8C31.7,20.7,31.7,20.7,31.8,20.8c0-0.1,0-0.2,0-0.2l0,0c0.2-0.6,0.2-1.2,0.2-1.9s-0.1-1.3-0.3-1.9
	l0,0.1l-0.1-0.3l-0.1,0c-0.2-0.5-0.3-0.9-0.6-1.3l0,0l0.1-0.1L31,15l-0.1-0.1c0-0.1-0.1-0.1-0.2-0.2l0,0c-1.9-1.3-4.1-2.2-6.6-2.6
	l-0.1,0c-0.1,0-0.1,0-0.2-0.1l0,0c-1.3-1-2.7-2-4.2-2.8l-0.1-0.1l-0.3-0.1C19.2,9,19.1,9,19,9c0,0,0,0,0,0h0l-0.6-0.1
	c-2-0.4-4.2-0.7-6.6-0.7c-1.3,0-2.6,0.1-3.8,0.2l0.2,0C7.3,8.5,6.6,8.6,5.8,8.9l0.1,0c-1.3,0.5-2.4,1.3-3.2,2.3l0,0l-0.2,0.2
	c-0.1,0.2-0.2,0.3-0.4,0.4l0,0l-0.4,0.2c-0.2,0.1-0.4,0.2-0.6,0.3l0,0c-0.2,0.1-0.3,0.3-0.3,0.6v0v0.1c0,0.2-0.1,0.4-0.2,0.6l0,0
	l-0.1,0.3c-0.1,0.2-0.2,0.5-0.3,0.8l0,0c-0.1,0.5-0.2,1.1-0.3,1.7l0,0.1v0.1l0.1,0.1c0.1,0.1,0.1,0.1,0.2,0.1c0,0,0,0,0,0h0
	c0,0.2,0,0.4,0,0.6s0,0.4,0,0.7l0,0c0.1,0.8,0.3,2.3,1.1,2.7c0.2,0.1,0.4,0.2,0.7,0.2c0.6,0,1.1-0.3,1.3-0.8l0,0l6.4,1.9
	c0.1,0,0.1,0,0.2,0c0.2,0,0.4-0.1,0.6-0.2l0,0c0.2,0.6,0.4,1.2,0.8,1.7l0,0c1,1.1,3.4,1.1,4.3-0.2c0.1,0.1,0.3,0.2,0.5,0.2h0
	c1.6,0,3.1,0.1,4.4,0.1c0.2,0,0.4,0,0.7,0c2.3,0,4.6-0.1,6.9-0.4l-0.3,0c0.2,0,0.3,0.1,0.5,0.1h0c0.1,0,0.2,0,0.3,0
	c0.4,0,0.7-0.1,1-0.3l0,0c0.1-0.1,0.2-0.1,0.3-0.2l0,0c0.5-0.1,0.8-0.2,1.2-0.4l0,0c0.3-0.2,0.5-0.5,0.5-0.9c0-0.1,0-0.1,0-0.2l0,0
	L31.8,20.8z M1.8,20.3c-0.4,0.1-0.9-0.9-1-2.2s0.1-2.5,0.6-2.5s0.9,0.9,1,2.2S2.2,20.2,1.8,20.3L1.8,20.3z M12.8,23.4
	c-0.9,0-1.7-1.5-1.8-3.3s0.6-3.4,1.6-3.4s1.7,1.4,1.8,3.3S13.7,23.3,12.8,23.4z M31.3,21.4C31.3,21.4,31.3,21.4,31.3,21.4
	c0,0.2-0.1,0.4-0.2,0.4l0,0C31,21.9,30.8,22,30.6,22l0,0c-0.9,0.3-2.1,0.5-3.2,0.6l-0.1,0c-2.1,0.2-4.6,0.3-7.1,0.3
	c-1.4,0-2.7,0-4.1-0.1l0.2,0c-0.2,0-0.3-0.1-0.3-0.3v0c0,0,0,0,0-0.1s0,0,0-0.1v0c0-0.2,0-0.5,0-0.7c0-1.3-0.2-2.6-0.7-3.8l0,0.1
	c-0.3-0.7-0.7-1.3-1.3-1.8l0,0c-0.2-0.1-0.4-0.2-0.6-0.3l0,0c-0.2-0.1-0.4-0.1-0.6-0.1c-0.6,0-1.1,0.3-1.5,0.8l0,0
	c-0.5,0.8-0.9,1.7-0.9,2.7v0c0,0.2,0,0.4,0,0.7c0,0.4,0,0.8,0,1.2l0-0.1c0,0,0,0,0,0c0,0.1-0.1,0.2-0.1,0.3l0,0
	c-0.1,0.1-0.1,0.1-0.2,0.1c0,0-0.1,0-0.1,0l0,0l-6.7-2c-0.2,0-0.3-0.2-0.3-0.4l0,0l0,0c0-0.1,0-0.3,0-0.4c0-0.6-0.1-1.1-0.1-1.7
	l0,0.1c-0.1-0.5-0.2-1-0.4-1.5l0,0c-0.1-0.1-0.1-0.2-0.2-0.3l0,0c-0.1-0.1-0.1-0.2-0.2-0.3l0,0c-0.2-0.2-0.4-0.4-0.7-0.4h0
	c-0.2,0-0.5,0.1-0.6,0.3l0,0c0-0.1,0-0.1,0-0.2c0.1-0.3,0.2-0.6,0.3-0.8l0,0l0.1-0.3c0.1-0.2,0.1-0.4,0.2-0.6l0,0v-0.1
	c0-0.1,0-0.2,0.1-0.2c0.2-0.1,0.3-0.2,0.5-0.3l0,0l0.4-0.2c0.2-0.1,0.4-0.3,0.6-0.5l0,0l0.2-0.2c0.5-0.6,1.1-1.1,1.8-1.6l0,0
	c-0.7,0.6-1.2,1.2-1.7,2l0,0V12c1,0,3.2,0.3,5,0.5c0-0.1-0.1-0.2-0.1-0.3s0-0.2,0.1-0.3l0,0c0.1-0.6,1.5-0.5,1.9-0.3
	c0.2,0.1,0.4,0.3,0.5,0.5l0,0c0.1,0.2,0.1,0.5-0.2,0.6l0.5,0.1c0,0,0,0,0,0c0,0,0.1,0,0.1-0.1c0,0,0,0,0,0l0,0
	c-0.1-0.1-0.1-0.3-0.1-0.3c-0.3-1-0.8-1.9-1.3-2.7l0,0c-0.4-0.6-1.3-0.6-2-0.6H7C7.4,9,7.8,9,8.2,9c1.1-0.1,2.3-0.2,3.6-0.2
	c1.9,0,3.8,0.2,5.6,0.5l-0.2,0c-1.1-0.1-2.3-0.2-3.5-0.2S11.2,9.2,10,9.3l0.2,0c0,0,0,0,0,0.1s0,0,0,0.1l0,0c0.3,0.5,0.6,1,0.9,1.6
	c0.3,0.6,0.5,1.2,0.9,1.7l0,0c0.2,0.3,0.9,0.3,1.4,0.3c1.3,0.2,2.8,0.3,4.3,0.3c2.2,0,4.3-0.2,6.3-0.6l-0.2,0
	c0.1,0.1,0.3,0.2,0.4,0.2h0c2.4,0.4,4.6,1.2,6.4,2.5l-0.1,0c-0.2,0.2-0.4,0.4-0.6,0.6l0,0c-0.3,0.4-0.5,0.8-0.6,1.3l0,0
	c0,0,0,0.1,0,0.1c0,0.1,0,0.2,0.1,0.3l0,0c0.1,0.1,0.2,0.2,0.9,0.1l0.4-0.1c0.3-0.1,0.6-0.1,0.8-0.2l0,0c0.1,0.4,0.1,0.9,0.1,1.4
	c0,0.6-0.1,1.2-0.2,1.8l0,0c0,0.1,0,0.1,0,0.2s0,0.2,0,0.2l0,0L31.3,21.4z"
      />
      <path
        d="M6.4,14.5l-0.5-0.1c-0.1,0-0.1-0.1-0.1-0.1s0.1-0.1,0.1-0.1l0,0l0.5,0.1c0.1,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0v0
	C6.5,14.4,6.4,14.5,6.4,14.5C6.4,14.5,6.4,14.5,6.4,14.5z"
      />
      <path
        d="M3.2,14l-0.5-0.1c-0.1,0-0.1-0.1-0.1-0.1c0,0,0,0,0,0v0c0-0.1,0.1-0.1,0.1-0.1c0,0,0,0,0,0l0,0l0.5,0.1
	c0.1,0,0.1,0.1,0.1,0.2c0,0,0,0,0,0l0,0C3.3,13.9,3.3,14,3.2,14C3.2,14,3.2,14,3.2,14L3.2,14L3.2,14z"
      />
      <path
        d="M22.7,19.9l4.4-0.3l2.4-0.1c0.4,0,0.6,0.2,0.5,0.6s-0.8,0.7-1.7,0.8L27.1,21l-3.5,0.2c-1,0.1-1.5-0.2-1.5-0.5
	c0,0,0-0.1,0-0.1C22,20.2,22.3,19.9,22.7,19.9C22.7,19.9,22.7,19.9,22.7,19.9C22.7,19.9,22.7,19.9,22.7,19.9z"
      />
      <path
        d="M17,15.5c0.5,0,1,0.2,1.5,0.4l0,0c1.6,0.7,2.2,1.9,2,2.1c-0.3,0.1-0.6,0.1-0.9,0.1c-0.1,0-0.2,0-0.3,0l0,0
	c-0.1,0-0.2,0-0.3,0c-0.8,0-1.5-0.1-2.2-0.4l0,0c-0.3-0.3-0.5-0.8-0.5-1.3c0-0.3,0.1-0.6,0.2-0.8l0,0C16.6,15.6,16.8,15.5,17,15.5
	C16.9,15.5,17,15.5,17,15.5L17,15.5L17,15.5z"
      />
    </SvgIcon>
  );
}

export function CarPassengerBackIcon() {
  return (
    <SvgIcon viewBox="0 0 40 27">
      <title>Car Passenger Front Icon</title>

      <path
        d="M6.7,14.3c0.1,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0v0v1c0,0.1-0.1,0.1-0.2,0.1l0,0l-2-0.2c-0.1,0-0.1-0.1-0.1-0.1
	c0,0,0,0,0,0l0,0v-1c0-0.1,0.1-0.2,0.1-0.1L6.7,14.3L6.7,14.3z"
      />
      <path
        d="M19.4,14.4L19.4,14.4c-0.1,0-0.2,0.1-0.2,0.2l0,0c0,0.1,0.1,0.2,0.2,0.2l0,0H20l0,0c0.1,0,0.2-0.1,0.2-0.2l0,0
	c0,0,0,0,0,0c0-0.1-0.1-0.2-0.2-0.2l0,0L19.4,14.4L19.4,14.4z"
      />
      <path
        d="M24.2,14.3c-0.1,0-0.2,0.1-0.2,0.2l0,0l0,0l0,0c0,0.1,0.1,0.2,0.2,0.2l0,0h0.7c0.1,0,0.2-0.1,0.2-0.2l0,0
	c0,0,0,0,0,0c0-0.1-0.1-0.2-0.2-0.2l0,0H24.2z"
      />
      <path
        d="M12.8,15.7L12.8,15.7c-0.1,0-0.2,0-0.3,0c-0.5,0-1,0-1.4-0.1l0,0c-0.7-0.1-1.4-0.5-1.9-0.9l0,0
	c-0.1-0.1-0.6-0.5-0.4-0.7c0.3-0.1,0.6-0.2,1-0.2h0c0.4,0,0.9-0.1,1.4-0.1c0.8,0,1.5,0.1,2.2,0.2l-0.1,0c0.6,0.3,0,1.4-0.3,1.7
	C13,15.6,12.9,15.7,12.8,15.7C12.8,15.7,12.8,15.7,12.8,15.7L12.8,15.7L12.8,15.7z"
      />
      <path d="M27.5,12.7c0,0,0-0.1,0-0.1s0-0.1,0-0.1l0,0v-0.1L27.5,12.7z" />
      <path d="M4.9,11.4C4.9,11.4,4.9,11.4,4.9,11.4C4.8,11.4,4.8,11.3,4.9,11.4L4.9,11.4L4.9,11.4z" />
      <path
        d="M0.2,19.8c0,0.2,0.2,0.3,0.3,0.4l0,0l1.1,0.5l1.1,0.2c0.3,1,1,1.8,2.1,1.8c0.8-0.1,1.5-0.6,1.9-1.2l0,0
	c2,0.3,3.9,0.5,4.6,0.6l0,0h0.2c0.6,0,2.2,0.1,3,0.1v0.1c0.3,1,1.2,1.8,2.3,1.8c0,0,0.1,0,0.1,0h0c1.5,0,2.3-1.1,2.7-2.5
	c0.1,0.1,0.2,0.2,0.4,0.2c0,0,0,0,0,0h0l7.6-1.1c0.2,0.4,0.6,0.6,1,0.7l0,0c0.2,0,0.3,0.1,0.5,0.1c0.6,0,1.1-0.3,1.5-0.7l0,0
	c0.2-0.3,0.4-0.7,0.5-1.1l0,0c0,0,0,0.1,0.1,0.1l0,0c0.1,0,0.1,0.1,0.2,0.1s0.2,0,0.2-0.1l0,0c0.2-0.1,0.3-0.3,0.3-0.5v0l0-1.1
	c0-0.1,0-0.2,0-0.3c0-0.9-0.1-1.7-0.3-2.5l0,0.1c-0.1-0.9-0.6-1.6-1.3-2.1l0,0c-0.1-0.1-0.5-0.2-1-0.4l-1.7-0.6c0,0,0-0.1-0.1-0.1
	l0,0c-0.2-0.2-0.5-0.4-0.8-0.5l0,0c-1-1.1-2.2-1.9-3.6-2.5l-0.1,0c-1-0.4-2.2-0.7-3.5-0.7l0,0h-0.5c-1.2-0.1-2.6-0.2-4-0.2
	S12.3,8.1,11,8.3l0.2,0c-1.1,0.1-2.1,0.3-3,0.6l0.1,0c-0.9,0.3-1.6,0.6-2.3,1l0.1,0L5.8,9.8c-0.4,0.2-0.8,0.5-1.1,0.7l0,0
	c-0.3,0.2-0.7,0.5-1.1,0.7l0,0c-0.4,0.2-0.9,0.4-1.4,0.5l-0.1,0c-0.4,0.1-0.7,0.4-0.8,0.9v0c0,0,0,0.1,0,0.1s0,0.1,0,0.1v0L1,13.5
	h0.2c0,0.2-0.1,0.3-0.1,0.5L1,14l-0.1,0.4c-0.1,0.3-0.1,0.7-0.1,1.1l0,0c0,0.1,0,0.2-0.1,0.3l0,0c-0.1,0.2-0.2,0.4-0.3,0.6l0,0
	c-0.1,0.2-0.2,0.4-0.3,0.7l0,0c-0.1,0.3-0.1,0.7-0.1,1C0,18.7,0.1,19.3,0.2,19.8L0.2,19.8L0.2,19.8z M26.5,13.1l-0.2-0.4v-0.1
	c0,0,0-0.1,0-0.1s0-0.1,0-0.1v0l0.1-0.3c0-0.2,0.2-0.3,0.4-0.3c0,0,0.1,0,0.1,0h0c0.2,0.1,0.4,0.2,0.6,0.3l0,0
	c0.1,0.1,0.1,0.2,0.2,0.3v0v0.1c0,0,0,0.1,0,0.1s0,0.1,0,0.1l0,0c-0.1,0.1-0.1,0.2-0.2,0.2l0,0L27,13.1L26.5,13.1z M29.2,18
	c0.1-1.2,0.6-2.2,1.1-2.1s0.8,1.1,0.7,2.4s-0.6,2.2-1.1,2.1S29.1,19.2,29.2,18z M16.4,20c0.1-1.5,0.8-2.7,1.6-2.6s1.2,1.4,1.1,2.9
	s-0.8,2.7-1.6,2.6S16.3,21.5,16.4,20z M9.7,20.5c0.1-0.1,0.4,0,0.5,0.2s0.1,0.5,0,0.6s-0.4,0-0.5-0.2S9.5,20.5,9.7,20.5L9.7,20.5z
	 M8.9,20.4c0.1-0.1,0.4,0,0.5,0.2s0.1,0.5,0,0.6S9,21.2,8.9,21S8.8,20.4,8.9,20.4L8.9,20.4z M0.7,18.8c0-0.2-0.1-0.5-0.1-0.8
	s0-0.6,0.1-0.8l0,0c0-0.1,0.1-0.2,0.1-0.3l0,0c0.1-0.2,0.3-0.5,0.4-0.7l0,0c0.1-0.2,0.1-0.4,0.1-0.6v0c0-0.1,0-0.3,0.1-0.6
	c0.1,0,0.3,0,0.5,0s0.3,0,0.5,0l0,0c0.6-0.1,1.1-0.5,1.4-1l0,0c0-0.1,0-0.1,0-0.2s0-0.1,0-0.2l0,0c-0.1-0.2-0.2-0.3-0.7-0.4
	c-0.4-0.1-0.8-0.2-1.2-0.2l0,0c0,0,0-0.1,0-0.1s0-0.1,0-0.1v0c0-0.1,0.2-0.2,0.2-0.2c0.6-0.2,1.1-0.4,1.6-0.6l0,0
	c0.4-0.2,0.8-0.4,1.1-0.6l0,0c0,0,0,0.1,0.1,0.1c0,0,0,0,0,0l0,0c3.1,0.1,6,0.3,8.9,0.7l-0.4,0c0.2,0,0.4-0.1,0.5-0.2v0
	c1.3-1,2.1-1.7,2.5-2c0,0,0.1-0.1,0.1-0.1s0-0.1-0.1-0.1l0,0c-0.3-0.1-0.7-0.2-1.1-0.2l-0.1,0c-0.9-0.1-1.9-0.1-3-0.1S10,9.2,9,9.3
	l0.1,0c0.6-0.1,1.3-0.3,2-0.4l0.1,0c1.2-0.1,2.5-0.2,3.9-0.2s2.7,0.1,4.1,0.2l-0.2,0L19.6,9c0.5,0.1,1.1,0.1,1.6,0.2h-0.2
	c-0.2,0-0.4,0-0.7,0c-0.9,0-1.7,0.2-2.4,0.6l0,0c-0.7,0.6-1.3,1.3-1.8,2l0,0c-0.1,0.2-0.4,0.7,0,0.7c2.5-0.1,7.9,0.1,9.9,0.2v0.1
	c0,0,0,0,0,0c0,0.1,0,0.2,0.1,0.3l0,0l0.2,0.4l0,0c0.1,0.1,0.2,0.1,0.2,0.1h0c0,0,0,0,0,0c0.1,0,0.1,0,0.1-0.1v0l0.1-0.3H27l0.6-0.2
	c0,0,0.1,0,0.1,0l0,0l1.5,0.5l0.9,0.3c0.4,0.2,0.6,0.6,0.8,1l0,0c-0.1-0.1-0.3-0.2-0.5-0.2c-0.2,0-0.5,0.1-0.6,0.3l0,0
	c-0.2,0.1-0.3,0.3-0.4,0.5l0,0c-0.7,1.1-1.1,2.4-1.2,3.8v0c0,0,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2s0,0.1,0,0.2l0,0l-0.8,0.1l-7.4,1
	c0.1-0.3,0.1-0.7,0.1-1.1c0-1-0.3-2-0.7-2.9l0,0c-0.3-0.5-0.9-0.8-1.5-0.8h-0.1c-0.6,0-1.1,0.3-1.5,0.7l0,0c-0.8,1.1-1.3,2.5-1.3,4
	c0,0.1,0,0.2,0,0.2v0c0,0.1,0,0.1-0.1,0.2l0,0c-0.1,0.1-0.3,0.2-0.5,0.2c0,0,0,0,0,0h0h-0.2c-0.5,0-1.2,0-1.9-0.1l-0.1-0.1
	c-0.2-0.3-0.4-0.6-0.6-0.9l0,0C11.6,20.2,11.3,20,11,20l0,0c-0.1,0-0.1,0-0.2,0s-0.1,0-0.2,0l0,0l-2.4-0.3c0,0-0.2-0.1-0.8,0.2H7.4
	l-5-0.6C2.2,19.2,2,19.1,1.8,19l0,0C1.8,19,1.1,18.8,0.7,18.8L0.7,18.8z M0.5,19.3c0.1-0.1,0.3,0,0.4,0.2S1,20,0.8,20.1
	s-0.3,0-0.4-0.2S0.4,19.4,0.5,19.3z"
      />
    </SvgIcon>
  );
}
